export const appVersion = '2024.09.10'
